import { replaceEmoticonsWithEmoji } from "@/utils/emoij";
import { LitElement, html } from "lit-element";
import { customElement } from "lit/decorators.js";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js"; // Import unsafeHTML
import DOMPurify from "dompurify"; // Import DOMPurify

@customElement("chat-history")
export class ChatHistory extends LitElement {
  private showChatHistory = false;
  private chatData: any = [];

  protected createRenderRoot() {
    return this;
  }

  toggleChatHistory() {
    this.showChatHistory = !this.showChatHistory;
    this.requestUpdate();
  }

  addMessage(event: CustomEvent) {
    const newMessage = event.detail;

    this.chatData.unshift(newMessage);

    if (this.chatData.length > 10) {
      this.chatData = this.chatData.slice(0, 10);
    }

    this.requestUpdate();
  }

  firstUpdated() {
    this.addEventListener("add-message", this.addMessage);
  }

  sanitizeMessage(message) {
    const emojiHtml = replaceEmoticonsWithEmoji(message);
    return DOMPurify.sanitize(emojiHtml, {
      ALLOWED_TAGS: ["span", "div"],
      ALLOWED_ATTR: ["class", "style"],
    });
  }

  render() {
    return html`
      <div>
        <button class="btn is-chat-history" @click="${this.toggleChatHistory}">
          ${this.showChatHistory ? "Hide Chat History" : "Show Chat History"}
        </button>
        ${this.showChatHistory
          ? html`
              <div class="chat-history">
                ${this.chatData.length === 0
                  ? html`<div class="chat-message no-message">
                      No messages yet. Start the conversation!
                    </div>`
                  : this.chatData.map(
                      (chat) => html`
                        <div class="chat-message">
                          <div>
                            <span class="message-user">${chat.user}</span>
                          </div>
                          <div class="message-text">
                            ${unsafeHTML(this.sanitizeMessage(chat.message))}
                          </div>
                        </div>
                      `
                    )}
              </div>
            `
          : ""}
      </div>
    `;
  }
}
